import SideNavigation, {
  SideNavigationProps,
} from '@cloudscape-design/components/side-navigation';

import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react'; // Assuming you're using AWS Amplify for authentication

const items: SideNavigationProps['items'] = [
  { type: 'link', text: 'Dashboard', href: '/dashboard' },
  { type: 'link', text: 'Network Map', href: '/map' },
  {
    type: 'link-group',
    text: 'Reports',
    href: '/reports',
    items: [
      {
        type: 'link',
        text: 'Terminal Usage',
        href: '/reports/terminal-usage',
      },
      {
        type: 'link',
        text: 'Top Five Usage',
        href: '/reports/top-five-usage',
      },
    ],
  },
  {
    type: 'link-group',
    text: 'Support',
    href: '/support',
    items: [
      {
        type: 'link',
        text: 'Contact Us',
        href: '/support',
      },
    ],
  },
  /* {
    type: 'expandable-link-group',
    text: 'Dev',
    href: '/dev',
    items: [
      { type: 'link', text: 'Dashboard', href: '/dev/dashboard' },
      { type: 'link', text: 'Dev1', href: '/dev/1' },
      { type: 'link', text: 'Dev2', href: '/dev/2' },
      { type: 'link', text: 'Dev3', href: '/dev/3' },
      { type: 'link', text: 'MSG', href: '/dev/msg' },
      { type: 'link', text: 'Bryan', href: '/dev/bryan' },
      { type: 'link', text: 'Cameron', href: '/dev/cameron' },
      { type: 'link', text: 'Matty', href: '/dev/matty' },
      { type: 'link', text: 'Venkata', href: '/dev/venkata' },
      { type: 'link', text: 'David', href: '/dev/david' },
    ],
  }, */
  /*   {
    type: 'expandable-link-group',
    text: 'Demo',
    href: '/demo',
    items: [
      { type: 'link', text: 'Style', href: '/demo/style' },
      { type: 'link', text: 'Table', href: '/demo/table' },
    ],
  },
  { type: 'link', text: 'Help', href: '/help' }, */
];

function getCurrentRouteName(pathname: string): string {
  const routesMap: { [key: string]: string } = {
    '/': 'Home',
    '/map': 'Map',
    '/reports/terminal-usage': 'Terminal Usage',
    '/reports/top-five-usage':'Top Five Usage',
    '/reports':'Reports',
    '/dashboard': 'Dashboard',
    '/support': 'Support',
    '/dev/1': 'Dev1',
    '/dev/2': 'Dev2',
    '/dev/3': 'Dev3',
    '/dev/msg': 'DevMsg',
    '/dev/bryan': 'DevBryan',
    '/dev/cameron': 'DevCameron',
    '/dev/matty': 'DevMatty',
    '/demo/style': 'Style',
    '/demo/table': 'Table',
    '/help': 'Help',
    '/log-out': 'Log Out',
  };

  return routesMap[pathname] || 'X2nSat, Inc.';
}

export default function SideNavigationComponent() {
  const location = useLocation();
  const { signOut } = useAuthenticator();
  // const [activeHref, setActiveHref] = useState(
  //   "/"
  // );
  const navigate = useNavigate();
  const handleNavigate = (link: string) => navigate(link);
  const handleFollow = (
    event: CustomEvent<SideNavigationProps.FollowDetail>
  ) => {
    if (event.detail.href === '/log-out') {
      event.preventDefault();
      signOut();
    }
    event.preventDefault();
    // setActiveHref(event.detail.href)
    handleNavigate(event.detail.href);
  };

  return (
    <SideNavigation
      activeHref={location.pathname}
      header={{
        href: location.pathname,
        text: getCurrentRouteName(location.pathname),
      }}
      items={items}
      onFollow={handleFollow}
    />
  );
}